// import CategoryBanner from "./../assets/category/oficedecor/subcategoryimage.jpg";

// import SubCategoryImage from "./../assets/subcategoryimage.webp";
import PrestigeBanner from "./../assets/category/cat2.webp";
import SpaceStylers from "./../assets/category/cat3.webp";
import MonumentsBanner from "./../assets/category/cat4.webp";
import EssenceofFormBanner from "./../assets/category/cat5.webp";
import ArtInFormBanner from "./../assets/category/cat6.webp";
import FlameHoldersBanner from "./../assets/category/cat7.webp";
import WallMasterpiecesBanner from "./../assets/category/cat14.webp";
import ReadDisplayBanner from "./../assets/category/cat8.webp";
import LightStyleBanner from "./../assets/category/cat9.webp";
import ATokenOfLoveBanner from "./../assets/category/cat10.webp";
import WarmSipsBanner from "./../assets/category/cat11.webp";
import GardenCharmBanner from "./../assets/category/cat12.webp";
import DeskEleganceBanner from "./../assets/category/cat13.webp";
//import PerfumeBanner from "./../assets/category/parfumecat.webp";
import PerfumeBanner from "./../assets/category/cat1.webp";

const categoryData = {
  category: [
    // {
    //   id: 101,
    //   categoryname: "Living Room",
    //   categorydesc: "Living Room DESC",
    //   categorymetakey: "mukemel,office,decor",
    //   categorybanner: CategoryBanner,
    //   categoryimage: CategoryImage,
    //   subcategories: [
    //     {
    //       id: 201,
    //       name: "Desk Decoration",
    //       subdesc: "Desk Decoration",
    //       subkey: "mukemel,decoration,desk",
    //       banner: CategoryBanner,
    //       image: SubCategoryImage,
    //       alt: "Decoration",
    //     },
    //     {
    //       id: 202,
    //       name: "Wall Decor Art",
    //       subdesc: "Wall Decor Art",
    //       subkey: "mukemel,decoration,desk",
    //       banner: CategoryBanner,
    //       image: SubCategoryImage,
    //       alt: "Decoration",
    //     },
    //   ],
    // },
    // {
    //   id: 102,
    //   categoryname: "Office Decor",
    //   categorydesc: "Office Decor DESC",
    //   categorymetakey: "mukemel,office,decor",
    //   categorybanner: CategoryBanner,
    //   categoryimage: CategoryImage,
    //   subcategories: [
    //     {
    //       id: 301,
    //       name: "Floor Sculptures",
    //       subdesc: "Floor Sculptures",
    //       subkey: "mukemel,decoration,desk",
    //       banner: CategoryBanner,
    //       image: SubCategoryImage,
    //       alt: "Decoration",
    //     },
    //   ],
    // },
    {
      id: 117,
      categoryname: "Perfume",
      categorydesc: "categories.perfume.desc",
      translationKey: "Perfume",
      categorymetakey: "categories.perfume.meta",
      categorybanner: "",
      categoryimage: PerfumeBanner,
      subcategories: [],
    },
    {
      id: 105,
      categoryname: "Prestige",
      categorydesc: "categories.prestige.desc",
      translationKey: "Prestige",
      categorymetakey: "categories.prestige.meta",
      categorybanner: "",
      categoryimage: PrestigeBanner,
      subcategories: [],
    },
    {
      id: 106,
      categoryname: "Space Stylers",
      categorydesc: "categories.spaceStylers.desc",
      translationKey: "Space Stylers",
      categorymetakey: "categories.spaceStylers.meta",
      categorybanner: "",
      categoryimage: SpaceStylers,
      subcategories: [],
    },
    {
      id: 107,
      categoryname: "Monuments",
      categorydesc: "categories.monuments.desc",
      translationKey: "Monuments",
      categorymetakey: "categories.monuments.meta",
      categorybanner: "",
      categoryimage: MonumentsBanner,
      subcategories: [],
    },
    {
      id: 108,
      categoryname: "Essence Of Form",
      categorydesc: "categories.essence_of_form.desc",
      translationKey: "Essence Of Form",
      categorymetakey: "categories.essence_of_form.meta",
      categorybanner: "",
      categoryimage: EssenceofFormBanner,
      subcategories: [],
    },
    {
      id: 109,
      categoryname: "Art In Form",
      categorydesc: "categories.art_in_form.desc",
      translationKey: "Art In Form",
      categorymetakey: "categories.art_in_form.meta",
      categorybanner: "",
      categoryimage: ArtInFormBanner,
      subcategories: [],
    },
    {
      id: 110,
      categoryname: "Flame Holders",
      categorydesc: "categories.flame_holders.desc",
      translationKey: "Flame Holders",
      categorymetakey: "categories.flame_holders.meta",
      categorybanner: "",
      categoryimage: FlameHoldersBanner,
      subcategories: [],
    },
    {
      id: 111,
      categoryname: "Wall Masterpieces",
      categorydesc: "categories.wall_masterpieces.desc",
      translationKey: "Wall Masterpieces",
      categorymetakey: "categories.wall_masterpieces.meta",
      categorybanner: "",
      categoryimage: WallMasterpiecesBanner,
      subcategories: [],
    },
    {
      id: 112,
      categoryname: "Read Display",
      categorydesc: "categories.read_display.desc",
      translationKey: "Read Display",
      categorymetakey: "categories.read_display.meta",
      categorybanner: "",
      categoryimage: ReadDisplayBanner,
      subcategories: [],
    },
    {
      id: 113,
      categoryname: "Light Style",
      categorydesc: "categories.light_style.desc",
      translationKey: "Light Style",
      categorymetakey: "categories.light_style.meta",
      categorybanner: "",
      categoryimage: LightStyleBanner,
      subcategories: [],
    },
    {
      id: 114,
      categoryname: "A Token Of Love",
      categorydesc: "categories.a_token_of_love.desc",
      translationKey: "A Token Of Love",
      categorymetakey: "categories.a_token_of_love.meta",
      categorybanner: "",
      categoryimage: ATokenOfLoveBanner,
      subcategories: [],
    },
    {
      id: 115,
      categoryname: "Warm Sips",
      categorydesc: "categories.warm_sips.desc",
      translationKey: "Warm Sips",
      categorymetakey: "categories.warm_sips.meta",
      categorybanner: "",
      categoryimage: WarmSipsBanner,
      subcategories: [],
    },
    {
      id: 116,
      categoryname: "Garden Charm",
      categorydesc: "categories.garden_charm.desc",
      translationKey: "Garden Charm",
      categorymetakey: "categories.garden_charm.meta",
      categorybanner: "",
      categoryimage: GardenCharmBanner,
      subcategories: [],
    },
    {
      id: 117,
      categoryname: "Desk Elegance",
      categorydesc: "categories.desk_elegance.desc",
      translationKey: "Desk Elegance",
      categorymetakey: "categories.desk_elegance.meta",
      categorybanner: "",
      categoryimage: DeskEleganceBanner,
      subcategories: [],
    },
  ],
};

export default categoryData;
